/**
 * List of events used by booking-luggage widget
 */
export const bookingLuggage = {
  CHOOSE_PER_PERSON_SWITCH: 'bookingLuggage.ChoosePerPersonSwitch'
}
